export const LOAD_FEATURE_LIST = 'role/LOAD_FEATURE_LIST';
export const LOAD_FEATURE_LIST_SUCCESS = 'role/LOAD_FEATURE_LIST_SUCCESS';
export const LOAD_FEATURE_LIST_ERROR = 'role/LOAD_FEATURE_LIST_ERROR';
